import React from 'react';

function Footer(props){
    return(
        <div className="footer">
            <div className="container">
                <div className="row">
                    <div className="col-6">
                        <h5>Academic Details of Developers</h5>
                        <p>
                            Bachelor in Technology<br/>
                            Computer Science and Engineering<br/>
                            Batch: 2017-21<br/>
                            Ambala College of Engineering and Applied Research<br/>
                        </p>
                    </div>
                    <div className="col-6">
                        <p>Designed and Developed by:</p>
                        <ul>
                            <li>Gurcharan Kohli</li>
                            <li>Utkarsh Bansal</li>
                            <li>Yogantar Chhibber</li>
                            <li>Manpreet Singh</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Footer;